class configData{
    constructor(_jsonData, _country, _lang) {
        let response = _jsonData;
        let configData;
        let countryData;

        countryData = [
            ['TW', response.l10nData.country.TW],
            ['KR', response.l10nData.country.KR],
            ['RU', response.l10nData.country.RU],
            ['MY', response.l10nData.country.MY],
            ['SA', response.l10nData.country.SA],
            ['SG', response.l10nData.country.SG],
            ['AE', response.l10nData.country.AE],
            ['ID', response.l10nData.country.ID],
            ['JP', response.l10nData.country.JP],
            ['QA', response.l10nData.country.QA],
            ['TH', response.l10nData.country.TH],
            ['PH', response.l10nData.country.PH],
            ['HK', response.l10nData.country.HK],
            ['UA', response.l10nData.country.UA],
            ['BY', response.l10nData.country.BY],
            ['LT', response.l10nData.country.LT],
            ['PL', response.l10nData.country.PL],
            ['GR', response.l10nData.country.GR],
            ['IL', response.l10nData.country.IL],
            ['KW', response.l10nData.country.KW],
            ['AT', response.l10nData.country.AT],
            ['US', response.l10nData.country.US],
            ['CA', response.l10nData.country.CA],
            ['DE', response.l10nData.country.DE],
            ['GB', response.l10nData.country.GB],
            ['FR', response.l10nData.country.FR],
            ['BR', response.l10nData.country.BR],
            ['IT', response.l10nData.country.IT],
            ['ES', response.l10nData.country.ES],
            ['CL', response.l10nData.country.CL],
            ['NO', response.l10nData.country.NO],
            ['SE', response.l10nData.country.SE],
            ['IE', response.l10nData.country.IE],
            ['PT', response.l10nData.country.PT],
            ['FI', response.l10nData.country.FI],
            ['DK', response.l10nData.country.DK],
            ['CH', response.l10nData.country.CH],
            ['AR', response.l10nData.country.AR],
            ['PE', response.l10nData.country.PE],
            ['MX', response.l10nData.country.MX],
            ['KZ', response.l10nData.country.KZ],
            ['UZ', response.l10nData.country.UZ],
            ['AZ', response.l10nData.country.AZ],
            ['GE', response.l10nData.country.GE],
            ['MD', response.l10nData.country.MD],
            ['AM', response.l10nData.country.AM]
        ];

        countryData = this.sortCountryData(countryData, _lang === 'zh' ? 'zh-hant' : _lang);
        countryData.push(['global', 'Global']);

        const languageData = {
            ko: '한국어',
            en: 'English',
            ar: 'العربية',
            zh: '中文－繁體',
            id: 'Bahasa Indonesia',
            ja: '日本語',
            ru: 'Русский',
            th: 'ภาษาไทย'
        }

        let configDataTemp =  {
            KR: {
                serviceName: 'plaync',
                country: _country,
                language: _lang,
                snsList: [
                ],
                menu: [
                    {name: response.l10nData.footer.companyLink , link: 'https://kr.ncsoft.com/', target: '_blank', isBold: false},
                    {name: response.l10nData.footer.termsOfService, link: 'https://www.plaync.com/policy/service', target: '_self', isBold: false},
                    {name: response.l10nData.footer.privacyPolicy, link: 'https://www.plaync.com/policy/privacy/ko', target: '_self', isBold: true},
                    {name: response.l10nData.footer.youthProtectionPolicy, link: 'https://www.plaync.com/policy/youthpolicy', target: '_self', isBold: true},
                    {name: response.l10nData.footer.operationPolicy, link: 'https://www.plaync.com/policy/operation/plaync', target: '_self', isBold: false},
                    {name: response.l10nData.footer.customerSupport, link: 'https://help.plaync.com/', target: '_self', isBold: false},
                ],
                copyrightCompany: 'Copyright ⓒ NCSOFT Corporation. All Rights Reserved.',
                infoAddress: response.l10nData.footer.infoAddress,
                companyInfo: `<a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank"><strong>${response.l10nData.footer.businessInformation}</strong></a>`,
                infoCS: response.l10nData.footer.infoCS,
                companyEmail: `${response.l10nData.footer.infoEmail} <a href="mailto:credit@ncsoft.com" class="email">credit@ncsoft.com</a>`,
                companyLink : `https://kr.ncsoft.com/kr/index.do`,
                countryData,
                languageData,
                channelingInfo : `${response.l10nData.footer.channelingInfo}`,
                familySites : [
                    {name : 'NCSOFT', link : 'https://kr.ncsoft.com/'},
                    {name : 'NC West', link : 'https://us.ncsoft.com/en'},
                    {name : 'NC Japan', link : 'https://www.ncsoft.jp/'},
                    {name : 'NC Taiwan', link : 'https://tw.ncsoft.com/'}
                ]
            },
            GLOBAL: {
                serviceName: 'plaync',
                country: _country,
                language: _lang,
                snsList: [
                ],
                menu: [
                    {name: response.l10nData.footer.companyLink , link: 'https://kr.ncsoft.com/', target: '_blank', isBold: false},
                    {name: response.l10nData.footer.privacyPolicy, link: 'https://www.plaync.com/policy/privacy/en', target: '_self', isBold: true},
                    {name: response.l10nData.footer.operationPolicy, link: 'https://www.plaync.com/policy/operation/plaync', target: '_self', isBold: false},
                    {name: response.l10nData.footer.cookiePolicy, link: 'https://www.plaync.com/policy/cookiepolicy', target: '_self', isBold: false},
                    {name: response.l10nData.footer.customerSupport, link: 'https://help.plaync.com/', target: '_self', isBold: false},
                ],
                copyrightCompany: 'Copyright ⓒ NCSOFT Corporation. All Rights Reserved.',
                infoAddress: response.l10nData.footer.infoAddress,
                companyInfo: `<a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank"><strong>${response.l10nData.footer.businessInformation}</strong></a>`,
                infoCS: response.l10nData.footer.infoCS,
                companyEmail: `${response.l10nData.footer.infoEmail} <a href="mailto:credit@ncsoft.com" class="email">credit@ncsoft.com</a>`,
                companyLink : `https://kr.ncsoft.com/en/index.do`,
                countryData,
                languageData,
                familySites : [
                    {name : 'NCSOFT', link : 'https://kr.ncsoft.com/'},
                    {name : 'NC West', link : 'https://us.ncsoft.com/en'},
                    {name : 'NC Japan', link : 'https://www.ncsoft.jp/'},
                    {name : 'NC Taiwan', link : 'https://tw.ncsoft.com/'}
                ]
            },
            US: {
                serviceName: 'plaync',
                country: _country,
                language: _lang,
                snsList: [
                ],
                menu: [
                    {name: response.l10nData.footer.companyLink , link: 'https://kr.ncsoft.com/', target: '_blank', isBold: false},
                    {name: response.l10nData.footer.privacyPolicy, link: 'https://www.plaync.com/policy/privacy/en', target: '_self', isBold: true},
                    {name: response.l10nData.footer.operationPolicy, link: 'https://www.plaync.com/policy/operation/plaync', target: '_self', isBold: false},
                    {name: response.l10nData.footer.cookiePolicy, link: 'https://www.plaync.com/policy/cookiepolicy', target: '_self', isBold: false},
                    {name: response.l10nData.footer.customerSupport, link: 'https://help.plaync.com/', target: '_self', isBold: false},
                    {name: 'Do Not Sell My Personal Information', link: 'https://help.plaync.com/qna/ticket?service=plaync&type=32099', target: '_self', isBold: false},

                ],
                copyrightCompany: 'Copyright ⓒ NCSOFT Corporation. All Rights Reserved.',
                infoAddress: response.l10nData.footer.infoAddress,
                companyInfo: `<a href="http://www.ftc.go.kr/bizCommPop.do?wrkr_no=1448504244" target="_blank"><strong>${response.l10nData.footer.businessInformation}</strong></a>`,
                infoCS: response.l10nData.footer.infoCS,
                companyEmail: `${response.l10nData.footer.infoEmail} <a href="mailto:credit@ncsoft.com" class="email">credit@ncsoft.com</a>`,
                companyLink : `https://kr.ncsoft.com/en/index.do`,
                countryData,
                languageData,
                familySites : [
                    {name : 'NCSOFT', link : 'https://kr.ncsoft.com/'},
                    {name : 'NC West', link : 'https://us.ncsoft.com/en'},
                    {name : 'NC Japan', link : 'https://www.ncsoft.jp/'},
                    {name : 'NC Taiwan', link : 'https://tw.ncsoft.com/'}
                ]
            }
        };

        configData = this.setConfigData(configDataTemp, _country);

        return configData;
    }

    sortCountryData(_countryData, _lang){
        let sortedCountryData = [];
        sortedCountryData = _countryData.sort(function(a,b){
            return a[1].localeCompare(b[1], _lang);
        })
        return sortedCountryData;
    }

    setConfigData(configTemp, country){
        let returnConfigData;

        if(country === 'KR'){
            returnConfigData = configTemp.KR;
        }
        else if(country === 'US'){
            returnConfigData = configTemp.US;
        }
        else{
            returnConfigData = configTemp.GLOBAL;
        }

        return returnConfigData;
    }
}

export default configData;